import React from "react";
import { Grid } from "@material-ui/core";
import "./boxSomeHeadersGL.css";

const BoxSomeHeadersGLPure = (props) => {
  const {
    titlesAndSubtitles,
    titleOne,
    titleTwo,
    titleThree,
    titleFour,
    subtitleOne,
    subtitleTwo,
    subtitleThree,
    subtitleFour,
    flexColumn1,
    startFourTitle
  } = props;

  return (
    <Grid
      container
      className={"boxSomeHeadersHLPure-container"}
      xs={12}
      lg={12}
      md={12}
      sm={12}
    >
      {titleOne !== "" || subtitleOne !== "" ? (
        <Grid item className={(flexColumn1) ? "boxSomeHeadersHLPure-containerText-flex " : "boxSomeHeadersHLPure-containerText"}>
          <span className={(flexColumn1) ? "boxSomeHeadersHLPure-text-title-flex" : "boxSomeHeadersHLPure-text-title"}>{titleOne}</span>
          <p className="boxSomeHeadersHLPure-subtitleTextHeader">
            {subtitleOne || '-'}
          </p>
        </Grid>
      ) : (
        ""
      )}

      {titleTwo !== "" || subtitleTwo !== "" ? (
        <Grid item className="boxSomeHeadersHLPure-containerText">
          <span className={"boxSomeHeadersHLPure-text-title"}>{titleTwo}</span>
          <p className="boxSomeHeadersHLPure-subtitleTextHeader">
            {subtitleTwo || '-'}
          </p>
        </Grid>
      ) : (
        " "
      )}

      {titleThree !== "" || subtitleThree !== "" ? (
        <Grid item className="boxSomeHeadersHLPure-containerText">
          <span className={"boxSomeHeadersHLPure-text-title"}>
            {titleThree}
          </span>
          <p className="boxSomeHeadersHLPure-subtitleTextHeader">
            {subtitleThree || '-'}
          </p>
        </Grid>
      ) : (
        ""
      )}

      {titleFour !== "" || subtitleFour !== "" ? (
        <Grid item className={startFourTitle ? "boxSomeHeadersHLPure-containerText-four" : "boxSomeHeadersHLPure-containerText"}>
          <span className={"boxSomeHeadersHLPure-text-title"}>{titleFour}</span>
          <p className="boxSomeHeadersHLPure-subtitleTextHeader">
            {subtitleFour || '-'}
          </p>
        </Grid>
      ) : (
        ""
      )}
      {/**Array titles and subtitles */}
      {/* {titlesAndSubtitles.map((item, index) => (
        <Grid
          item
          xs={12}
          lg={12}
          md={12}
          sm={12}
          className="boxSomeHeadersHLPure-containerText"
        >
          <span className={"boxSomeHeadersHLPure-text-title"}>
            {item.title}
          </span>
          <p className="boxSomeHeadersHLPure-subtitleTextHeader">
            {item.subtitle}
          </p>
        </Grid>
        
      ))} */}
    </Grid>
  );
};

export { BoxSomeHeadersGLPure as default };
